import { render, staticRenderFns } from "./evaluacion-seleccion-proveedores-ver.vue?vue&type=template&id=57bd8130&scoped=true&"
import script from "./evaluacion-seleccion-proveedores-ver.vue?vue&type=script&lang=js&"
export * from "./evaluacion-seleccion-proveedores-ver.vue?vue&type=script&lang=js&"
import style0 from "./evaluacion-seleccion-proveedores-ver.vue?vue&type=style&index=0&id=57bd8130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd8130",
  null
  
)

export default component.exports